import * as React from "react";
import { AccountAdviceType } from "../../../../../../Wrap/Constants/Enums/Apply/AccountAdviceType";
import { CurrencyCode } from "../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { InstrumentSelections } from "../../../../../../Wrap/Models/Models/InstrumentSelection/InstrumentSelections";
import { GiaContributionModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/PersonalPortfolio/GiaContributionModel";
import { IsaContributionModel } from "../../../../../../Wrap/Models/Models/Processes/OneOffPayment/Isa/IsaContributionModel";
import { PensionContributionModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { WhatIfToolDetailModel } from "../../../../../../Wrap/Models/Models/Processes/WhatIfTool/WhatIfToolDetailModel";
import { getISTPaymentAmount, initWeighting } from "../../../../../Shared/IST/Components/Shared/Utils";
import { InvestmentSelectionTool } from "../../../../../Shared/IST/InvestmentSelectionTool";
import { ProcessType } from "../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { ClientAccountStore } from "../../../../Stroes/Variable";
import { SubAccountTypeHelper } from "../../Common/Helpers/SubAccountTypeHelper";

interface IEditInvestmentSelectionProps extends IProcessComponentProps {
    data: GiaContributionModel | IsaContributionModel | PensionContributionModel;
    type: SubAccountType;
    extraInfo: WhatIfToolDetailModel;
}

interface IEditInvestmentSelectionState {}

export class EditInvestmentSelection extends ProcessComponent<
    IEditInvestmentSelectionProps,
    IEditInvestmentSelectionState
> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private setPrepopulateToReadOnly(investments: InstrumentSelections) {
        const { extraInfo, type } = this.props;
        if (!extraInfo.CurrentHoldings || extraInfo.CurrentHoldings.length == 0) {
            return investments;
        }
        const instructionData: any[] = (investments?.Instruments || []).concat();
        extraInfo?.CurrentHoldings[0].IndividualInvestments.forEach((ele) => {
            ele.Investments.forEach((fund) => {
                const index = instructionData.findIndex((item) => item.Instrument?.ProductId == fund.ProductId);
                if (index > -1) {
                    instructionData[index].ExistingFund = Number((fund.Allocation * 100).toFixed(2));
                } else {
                    instructionData.push({
                        Instrument: { ...fund, ProductCode: fund.InstrumentCode, Name: fund.DisplayName },
                        Single: initWeighting(),
                        Transfer: initWeighting(),
                        ClientRegular: initWeighting(),
                        EmployerRegular: initWeighting(),
                        ThirdPartyRegular: initWeighting(),
                        EmployerSalaryDeductionRegular: initWeighting(),
                        ExistingFund: Number((fund.Allocation * 100).toFixed(2)),
                    });
                }
            });
        });

        extraInfo?.CurrentHoldings[0].ModelPortfolioInvestments.forEach((ele) => {
            ele.Investments.forEach((fund) => {
                const index = instructionData.findIndex((item) => item.Instrument?.ProductId == fund.ProductId);
                if (index > -1) {
                    instructionData[index].ExistingFund = Number((fund.Allocation * 100).toFixed(2));
                } else {
                    instructionData.push({
                        Instrument: { ...fund, ProductCode: fund.InstrumentCode, Name: fund.DisplayName },
                        Single: initWeighting(),
                        Transfer: initWeighting(),
                        ClientRegular: initWeighting(),
                        EmployerRegular: initWeighting(),
                        ThirdPartyRegular: initWeighting(),
                        EmployerSalaryDeductionRegular: initWeighting(),
                        ExistingFund: Number((fund.Allocation * 100).toFixed(2)),
                    });
                }
            });
        });
        return {...this.getInvestmentSelections(), Instruments: instructionData };
    }

    private getInvestmentSelections()
    {
        const { type } = this.props;
        const isSIPP = SubAccountTypeHelper.isOnPlatformPension(type);
        if(!isSIPP)
        {
            return this.props.data?.Contribution?.InstrumentSelections;
        }
        else{
            return this.props.data?.Contribution?.["PreRetirementInstrumentSelections"];
        }
    }

    private onInvestmentChange(changes)
    {
        const { onChange, data, type } = this.props;
        const isSIPP = SubAccountTypeHelper.isOnPlatformPension(type);
        if(!isSIPP)
        {
            this.onDataChange(
                (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                changes,
                data.Contribution,
                "InstrumentSelections"
            )
        }
        else{
            this.onDataChange(
                (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                changes,
                data.Contribution,
                "PreRetirementInstrumentSelections"
            )
        }
    }

    public render(): JSX.Element {
        const { onChange, data, type } = this.props;
        const paymentAmount = getISTPaymentAmount(
            data?.Contribution,
            SubAccountTypeHelper.isPP(type) ? "GiaTransfers" : "IsaTransfers"
        );
        const isSIPP = SubAccountTypeHelper.isOnPlatformPension(type);
        const modelData: typeof data.Contribution = JSON.parse(JSON.stringify(data?.Contribution));
        const params = getQueryParameters();
        const clAccountId = params["clAccountId"];

        return (
            <div>
                <h2 className="mb-20">Investment selection</h2>
                <InvestmentSelectionTool
                    withReRegistrationTransferIn={false}
                    data={this.setPrepopulateToReadOnly(!isSIPP ? data?.Contribution?.InstrumentSelections:data?.Contribution?.["PreRetirementInstrumentSelections"])}
                    modelData={{
                        ...modelData,
                        CashInstrument: data.CashInstrument,
                        OwnerHierarchyId: data.OwnerHierarchyId
                    }}
                    onRef={(ref) => this.appendChild(ref)}
                    onChange={(changes) =>{this.onInvestmentChange(changes)}}
                    showErrorMsgPopUp={(msg) => this.props.showErrorMsgPopUp(msg)}
                    type={ProcessType.WhatIf}
                    hiercharyId={params["subaccounthierarchyid"]}
                    headAccountHierarchyId={params["hierarchyid"]}
                    companyCode={ClientAccountStore.getClientAccountInfo()?.Company}
                    claccountId={clAccountId}
                    product={this.props.type}
                    paymentAmount={{ Amount: paymentAmount, Currency: CurrencyCode.GBP }}
                    bankAccounts={[]}
                    onBankChange={(bankInfo) => {}}
                    onDistributionDividendOptions={(changes) => {}}
                    decisionMakerHierarchyId={data?.Contribution?.HierarchyId}
                    accountAdviceType={
                        ClientAccountStore.getClientAccountInfo()?.Discretionary
                            ? AccountAdviceType.Discretionary
                            : AccountAdviceType.NonDiscretionary
                    }
                    accountServiceProposition={data?.AccountServiceProposition}
                    onDecisionMakerChange={(v) => this.onDataChange(onChange, v, data, "Contribution")}
                />
            </div>
        );
    }
}
